import React from 'react';
import { RouteComponentProps } from 'react-router';
import { PublicLayout } from 'components/public/PublicLayout';
import Locale, { LanguageCode } from 'localization/Localization';

interface RouteParams
{
	lang: LanguageCode;
}

export class EulaPage extends React.Component<RouteComponentProps<RouteParams>>
{
	public componentDidMount()
	{
		document.title = Locale.getPageTitleText(Locale.get('eula_header'));
	}

	public render()
	{
		return (
			<PublicLayout>
				<div className="eula-container">
					<h1>{Locale.get('eula_header')}</h1>
					<p>{Locale.get('eula')}</p>
				</div>
			</PublicLayout>
		);
	}
}
